module.exports = __webpack_public_path__ + "static/step1-be675401c34d7f8235fe502b1013676d.png";